/* ADD SOFTSKILL ABILITY */
export const REMOVE_SOFTSKILL_ABILITY_USER = "REMOVE_SOFTSKILL_ABILITY_USER"
export const REMOVE_SOFTSKILL_ABILITY_USER_SUCCESS =
  "REMOVE_SOFTSKILL_ABILITY_USER_SUCCESS"
export const REMOVE_SOFTSKILL_ABILITY_USER_CLEAN =
  "REMOVE_SOFTSKILL_ABILITY_USER_CLEAN"
export const REMOVE_SOFTSKILL_ABILITY_USER_ERROR =
  "REMOVE_SOFTSKILL_ABILITY_USER_ERROR"
